module.exports = __webpack_public_path__ + "img/arrow-90deg-left.5f4cc2f4.svg";